export var ReportTriggerChannelType;
(function (ReportTriggerChannelType) {
    ReportTriggerChannelType["Email"] = "email";
})(ReportTriggerChannelType || (ReportTriggerChannelType = {}));
export var TimeGranularityType;
(function (TimeGranularityType) {
    TimeGranularityType["Minute"] = "minute";
    TimeGranularityType["Hour"] = "hour";
    TimeGranularityType["Day"] = "day";
    TimeGranularityType["Week"] = "week";
    TimeGranularityType["Month"] = "month";
    TimeGranularityType["Quarter"] = "quarter";
    TimeGranularityType["Year"] = "year";
})(TimeGranularityType || (TimeGranularityType = {}));
